import { useState, useEffect } from 'react'
import { Table, TableBody, TableHead, TableRow, TableCell, Paper, Button, Grid, Checkbox, IconButton ,Tooltip} from "@material-ui/core";
import { globalGetService, globalDeleteService } from '../../../utils/globalApiServices';
import { useSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { EngineModuleList, EngineModuleCRU } from '../components';
import { checkApiStatus, } from '../../../utils';
import { EmptyCollection, PageLoader, DeletePopUp } from '../../../shared_elements';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { permissionCheckFnforCamo } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import FilterComponent from '../../../shared_elements/components/filter_component';
import { template_Filter } from '../components';
import Pagination from '../../../shared_elements/components/Pagination';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { ConfgureTab } from '../../fleet/components';
import STabsLoader from '../../../shared_elements/components/skeleton_loader/STabsLoader';
const EngHeaders = ({ toggleBulkOps, bulk, data, setBulk }) => {
    return (
        <TableHead>
            <TableRow>
                {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ? <TableCell>
                    <Checkbox
                        color="primary"
                        size="small"
                        onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', data)}
                        checked={data?.length === bulk?.ids?.length && data?.length > 0}
                    />
                    {bulk?.type && bulk?.ids?.length ?
                        <>
                            <Tooltip title='Delete' arrow placement='top'>
                                <IconButton className='delete-icon'>
                                    <DeleteOutlinedIcon color='secondary' onClick={() => setBulk({ ...bulk, title: 'Delete', modal: true })} />
                                </IconButton>
                            </Tooltip>({bulk?.ids?.length})
                        </> : null}
                </TableCell> : null}
                <TableCell style={{ minWidth: "120px" }}> Action(s) </TableCell>
                <TableCell style={{ minWidth: "120px" }}> Engine Family  </TableCell>
                <TableCell style={{ minWidth: "170px" }}> Remarks </TableCell>
                <TableCell style={{ minWidth: "190px" }}> Attachment </TableCell>
                <TableCell style={{ minWidth: "80px" }}> Active </TableCell>
                <TableCell style={{ minWidth: "100px" }}> Created By </TableCell>
                <TableCell style={{ minWidth: "100px" }}> Modified By </TableCell>
            </TableRow>
        </TableHead>
    )
}

function EngineModule({ match }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false)
    const [skeltonLoader, setSkeltonLoader] = useState(false)
    const [filter, setFilter] = useState({});
    const [engList, setEngList] = useState({ modal: false, data: null })
    const [data, setData] = useState({ list: [], pagination: {} })
    const [engCRU, setEngCRU] = useState({ modal: false, data: null, type: '' })
    const [egineFamily, setEngineFamily] = useState([])
    const [userList, setUserList] = useState({ createdBy: [], updatedBy: [] })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })

    useEffect(() => {
        getEngModuleList({ per_page: 250 }, 'skeltonLoader')
        getEngineFamily()
        getUserList()
        trackActivity('Engine Module - Airworthiness Management', {
            event_type: 'Engine Module Templates Section Page Visited',
            page_title: 'Engine Module Templates Section'
        });
    }, [])

    const getEngineFamily = () => {
        globalGetService(`camo/engine_dropdown/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setEngineFamily(response?.data?.data?.engine_family)
                }
            })
    }
    const getUserList = () => {
        globalGetService(`camo/template/userlist/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setUserList({ createdBy: response?.data?.created_by_list, updatedBy: response?.data?.updated_by_list })
                }
            })
    }
    const getEngModuleList = (query, loaderType) => {
        loaderType === "skeltonLoader" ? setSkeltonLoader(true) : setLoading(true)
        globalGetService(`camo/engine_template/sample/`, query)
            .then((response) => {
                loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false)
                if (checkApiStatus) {
                    setData(response?.data?.data)
                    delete query?.page
                    delete query?.per_page
                    setFilter(query)
                } else {
                    loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false)
                }
            })
    }

    const deleteEngList = () => {
        setLoading(true)
        globalDeleteService(!bulk?.ids?.length ? `camo/template/sample/${engList?.data?.id}/` : `camo/template/bulk_delete/`, { delete_ids: bulk?.ids.map(item => item?.id) })
            .then((response) => {
                setLoading(false); setEngList({ modal: false }); getEngModuleList({ per_page: 250 })
                setBulk({ modal: false, ids: [], title: '', type: '' })
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Engine Module -Airworthiness Management', {
                        event_type: 'Engine Module -Templates Delete',
                        page_title: 'Engine Module - Templates Deleted Success',
                        deleted_id: engList?.data?.id,
                        success_msg: response?.data?.message
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Engine Module -Airworthiness Management', {
                        event_type: 'Engine Module -Templates  Delete ',
                        page_title: 'Engine Module -Templates Delete Failed ',
                        deleted_id: engList?.data?.id,
                        error_msg: response?.data?.message
                    })
                }

            })
    }
    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem?.id !== item.id) })
        }
    }

    const filterObj = Object.assign({}, filter, delete filter.sort, delete filter.sortInfo)
    let filterOptions = template_Filter
    filterOptions = {
        ...filterOptions,
        engine_family: {
            ...filterOptions.engine_family,
            options: egineFamily,
        },
        created_by: {
            ...filterOptions.created_by,
            options: userList?.createdBy || [],
        },
        updated_by: {
            ...filterOptions.updated_by,
            options: userList?.updatedBy || [],
        },
    }
    const onDeleteTempFileRes = (item) => {
        if (engCRU?.data?.id && engCRU?.modal) {
            setEngCRU({
                ...engCRU,
                data: {
                    ...engCRU.data,
                    file_path: engCRU?.data?.file_path === item?.file_path && null,
                    file_name: engCRU?.data?.file_name === item?.file_name && null
                }
            })
        }
    }
    const tabsLoaderCount = window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 5 : 9;
    return (
        <>
            <section className='camo-template-module'>
                <ConfgureTab tabIndex="engine" />
                {skeltonLoader ? <STabsLoader count={tabsLoaderCount} /> :
                    <Paper square variant='outlined' style={{ padding: '2px 5px' }}>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid item md={9} sm={6} xs={6}>
                                <div>
                                    <FilterComponent
                                        filter={filterObj}
                                        filterMenu={filterOptions}
                                        getResponseBack={(applyFilter) => getEngModuleList({ ...applyFilter, page: 1, per_page: engList?.pagination?.per_page || 250 }, 'pageLoader')}
                                    />
                                </div>
                            </Grid>
                            <Grid item md={3} sm={6} xs={6}>
                                {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) ?
                                    <ul style={{ padding: "8px", float: "right", }} className="list-inline"  >
                                        <li className='list-inline-item' >
                                            <Button variant='contained' color='primary' size='small' onClick={() => setEngCRU({ modal: true, data: null, type: 'add' })}>+ ADD TEMPLATE</Button>
                                        </li>
                                    </ul>
                                    : null}
                            </Grid>
                        </Grid>
                    </Paper>}
                     {skeltonLoader ? <STableLoader count={tabsLoaderCount} /> :
                    <Paper variant='outlined' square style={{ marginBottom: "5px" }}>
                        <div style={{ height: `${window.innerHeight - 230}px`, overflow: 'auto' }}>
                            <Table className='mui-table-format' stickyHeader={true}>
                                <EngHeaders toggleBulkOps={toggleBulkOps} bulk={bulk} data={data?.list} setBulk={setBulk} />
                                <TableBody>
                                    {data?.list?.length > 0 && data?.list?.map((item, index) =>
                                        <EngineModuleList
                                            item={item}
                                            key={index}
                                            toggleBulkOps={toggleBulkOps}
                                            bulk={bulk}
                                            onEditFn={() => setEngCRU({ modal: true, data: item, type: 'edit' })}
                                            onDeleteFn={() => setEngList({ modal: true, data: item })}
                                            onViewFn={() => setEngCRU({ modal: true, type: 'view', data: item })}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                            {!data?.list?.length ? <EmptyCollection title="No Records Founds" /> : null}
                        </div>
                        <Pagination
                            pagination={data?.pagination}
                            onChangePage={(event, newPage) => getEngModuleList({ ...filter, page: newPage + 1, per_page: data?.pagination?.per_page || 250 }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getEngModuleList({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                    </Paper>}
                {engCRU?.modal ?
                    <EngineModuleCRU
                        engModuleData={engCRU?.data}
                        modeType={engCRU?.type}
                        getTempDelFileRes={(id) => onDeleteTempFileRes(id)}
                        modalCloseFn={() => setEngCRU({ modal: false, data: null, type: "" })}
                        getResponseBack={() => getEngModuleList({ per_page: data?.pagination?.per_page || 250 }, 'pageLoader')}
                    /> : null
                }
                {engList.modal || bulk.modal ?
                    <DeletePopUp
                        title='Delete Template'
                        deleteRecordFn={() => deleteEngList()}
                        modal={true}
                        content={`Do you really want to delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record`}
                        toggleModalFn={() => bulk.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : setEngList({ modal: false })}
                    /> : null

                }
                {isLoading ? <PageLoader /> : null}
            </section>
        </>
    )
}

export default withRouter(EngineModule)